import { render, staticRenderFns } from "./PlaceContactData.vue?vue&type=template&id=3a85ec23&scoped=true"
import script from "./PlaceContactData.vue?vue&type=script&lang=ts"
export * from "./PlaceContactData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85ec23",
  null
  
)

export default component.exports